const initialState = {
  profileOpen: false,
  shouldShowUserButton: true,
  cartToQuantity: {},
  usedComponents: {},
  isB2BNoticeBannerVisible: false,
  isNotificationDismissedB2B: false,
  showB2Bpopup: false,
  distributorNoticeBanner: false,
  distributorNoticeBannerOverride: false,
  selectedProduct: null,
  categories: null,
  didMeetMOV: false,
  balanceCheckLoading: false,
  hasEnoughBalance: false,
  phoneNumber: null,
  checkbox: false,
  method: "",
  distributor: null,
  branch: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "SET_B2B_PROFILE_OPEN":
      return { ...state, profileOpen: payload };

    case "HIDE_B2B_USER_BUTTON":
      return { ...state, shouldShowUserButton: false };
    case "B2B_CART_TO_QUANTITY":
      if (payload.fromCart) {
        let newCartToQuantity = { ...state.cartToQuantity };
        delete newCartToQuantity[payload.id];
        newCartToQuantity = Object.fromEntries(
          Object.entries(newCartToQuantity).filter(
            ([key, value]) => value !== 0
          )
        );
        return { ...state, cartToQuantity: newCartToQuantity || {} };
      }
      let newCartToQuantity = { ...state.cartToQuantity };
      newCartToQuantity[payload.id] = payload.value;
      newCartToQuantity = Object.fromEntries(
        Object.entries(newCartToQuantity).filter(([key, value]) => value !== 0)
      );
      return { ...state, cartToQuantity: newCartToQuantity || {} };
    case "EMPTY_CART":
      return { ...state, cartToQuantity: {} };
    case "SET_B2B_NOTICE_BANNER_VISIBILITY":
      return { ...state, isB2BNoticeBannerVisible: payload };
    case "DISMISS_B2B_NOTICE_BANNER":
      return { ...state, isNotificationDismissedB2B: true };
    case "SHOW_B2B_POPUP":
      return { ...state, showB2Bpopup: payload };
    case "SET_DISTRIBUTOR_NOTICE_BANNER":
      return {
        ...state,
        distributorNoticeBanner: payload,
      };
    case "SET_DISTRIBUTOR":
      return {
        ...state,
        distributor: payload,
      };
    case "SET_DISTRIBUTOR_NOTICE_BANNER_OVERRIDE":
      return {
        ...state,
        distributorNoticeBannerOverride: payload,
      };
    case "UPDATE_USED_COMPONENTS":
      const newUsedComponents = state.usedComponents;
      if (payload.product.type_of_product == "stocked") {
        newUsedComponents[payload.product.id] =
          (newUsedComponents[payload.product.id] || 0) + payload.quantityDelta;
      } else if (payload.product.type_of_product == "composite") {
        Object.entries(payload.product.components).forEach(
          ([productId, product]) => {
            newUsedComponents[productId] =
              (newUsedComponents[productId] || 0) +
              payload.quantityDelta * product.required_amount;
          }
        );
      }
      return {
        ...state,
        usedComponents: newUsedComponents,
      };
    case "SET_PRODUCT":
      return {
        ...state,
        selectedProduct: payload,
      };
    case "SET_MEET_MOV":
      return {
        ...state,
        didMeetMOV: payload,
      };
    case "FETCH_CATEGORIES":
      return {
        ...state,
        categories: payload,
      };
    case "BALANCE_CHECKING_LOADING":
      return {
        ...state,
        balanceCheckLoading: payload,
      };
    case "CHECK_WALLET_BALLANCE":
      return {
        ...state,
        hasEnoughBalance: payload,
      };

    case "SET_PHONE_NUMBER":
      return {
        ...state,
        phoneNumber: payload,
      };

    case "SET_VERIFIED_PHONE":
      return {
        ...state,
        checkbox: payload,
      };

    case "SET_BRANCH_DETAILS":
      return {
        ...state,
        branch: payload,
      };

    case "SET_METHOD":
      return {
        ...state,
        method: payload,
      };
    default:
      return state;
  }
};
